import Head from "next/head";
import React from "react";
import { constants } from "../constants";
import Image from "next/image";
import TributeTree from "../public/Tribute tree_28x.jpg";
import Link from "next/link";

export default function TermsOfService() {
    return (
        <>
            <Head>
                <title>Privacy Policy - {constants.siteTitle}</title>
            </Head>
            <div className="relative h-96">
                <Image
                    src={TributeTree}
                    layout="fill"
                    objectFit="cover"
                    objectPosition="50% 10%"
                    className="filter brightness-60"
                    alt="Photo of the tribute tree"
                />
                <div className="relative mx-auto container flex h-full items-center justify-center py-12">
                    <h1 className="text-5xl text-white">Privacy Policy</h1>
                </div>
            </div>
            <div className="mx-auto container max-w-prose my-12 text-gray-700 space-y-4">
                <div className="mx-auto text-xl leading-relaxed space-y-4">
                    <h2 className="text-2xl ml-6 mt-4">
                        What kinds of information do we collect?
                    </h2>
                    <p>
                        To provide the places for you to remember people and
                        animals in your life, we must process information about
                        you. The type of information that we collect depends on
                        how you use Light up a Life. You can change and delete
                        information that we collect by contacting supporter care
                        on 0191 246 9123 or by emailing
                        <Link href="mailto:supportercare@stoswaldsuk.org">
                            <a className="ml-1 text-loving-500">
                                supportercare@stoswaldsuk.org
                            </a>
                        </Link>
                        .
                    </p>

                    <h2 className="text-2xl ml-6 mt-4">
                        Things that you provide.
                    </h2>
                    <p>
                        We collect the content, communications and other
                        information you provide when you use Light up a Life,
                        including when you sign up for an account, create or
                        share content and message or communicate with others.
                        This can include information in or about the content
                        that you provide, such as the location of a photo or the
                        date a file was created. Our systems{" "}
                        <span className="underline">do not</span> process
                        content and communications that you and others provide
                        to analyse context and what&apos;s in them for any purpose.
                    </p>
                    <p>
                        We also collect contact information if you choose to
                        upload, sync or import it from a device (such as an
                        address book or call log or SMS log history), we will
                        not do anything with this information other than to
                        understand whether you are already an active supporter
                        of St Oswald&apos;s Hospice. If you are in St Oswald&apos;s
                        Hospice&apos;s supporter database we will note that you are
                        also a member of Light up a Life.
                    </p>
                    <p>
                        We do not collect information about how you use Light up
                        a Life, such as the types of content that you view or
                        engage with, the features you use, the actions you take,
                        the people or accounts you interact with and the time,
                        frequency and duration of your activities.
                    </p>

                    <h2 className="text-2xl ml-6 mt-4">
                        How do we use this information?
                    </h2>
                    <p>
                        We use the information that we have (subject to choices
                        you make) as described below and to provide and support
                        your Light up a Life places.
                    </p>
                    <ul className="list-disc pl-8">
                        <li>
                            Provide, personalise and improve Light up a Life.
                        </li>
                        <li>
                            We use the information that we have to deliver Light
                            up a Life and to promote safety, integrity and
                            security.
                        </li>
                        <li>
                            We use the information that we have to verify
                            accounts and activity, combat harmful conduct,
                            detect and prevent spam and other bad experiences,
                            maintain the integrity of Light up a Life, and
                            promote safety and security. For example, we use
                            data that we have to investigate suspicious activity
                            or violations of our Terms or Policies, or to detect
                            when someone needs help.
                        </li>
                        <li>Communicate with you.</li>
                    </ul>
                    <p>
                        We do not use the information that we have to send you
                        marketing communications. However we may use it to
                        communicate with you about Light up a Life and let you
                        know about our Policies and Terms. We also use your
                        information to respond to you when you contact us.
                    </p>

                    <h2 className="text-2xl ml-6 mt-4">
                        How is this information shared?
                    </h2>
                    <p>
                        When you share and communicate using Light up a Life,
                        you choose the audience for what you share. For example,
                        your post can be visible to everyone, to people who you
                        invite, or it can be completely private. You select the
                        audience. Your network can see actions that you have
                        taken on Light up a Life.
                    </p>
                    <p>
                        Public information can be seen by anyone, on or off
                        Light up a Life, including if they don&apos;t have an
                        account. This includes your username, any information
                        you share with a public audience, information in your
                        public profile on Light up a Life, and content you share
                        on a Light up a Life space.
                    </p>

                    <h2 className="text-2xl ml-6 mt-4">
                        Sharing with third-party partners
                    </h2>
                    <p>
                        We don&apos;t sell any of your information to anyone and we
                        never will. We only share information with the company
                        which has developed the website for us and which stores
                        the data on our behalf.
                    </p>

                    <h2 className="text-2xl ml-6 mt-4">
                        What is our legal basis for processing data?
                    </h2>
                    <p>
                        We collect, use and share the data that we have in the
                        ways described above:
                    </p>
                    <ul className="list-disc pl-8">
                        <li>as necessary to fulfil our Terms of Service;</li>
                        <li>
                            consistent with your consent, which you may revoke
                            at any time through our supporter care service 0191
                            246 9123 or by emailing
                            <Link href="mailto:supportercare@stoswaldsuk.org">
                                <a className="ml-1 text-loving-500">
                                    supportercare@stoswaldsuk.org
                                </a>
                            </Link>
                        </li>
                        <li>
                            to protect your vital interests, or those of others
                        </li>
                        <li>as necessary in the public interest and</li>
                    </ul>

                    <h2 className="text-2xl ml-6 mt-4">
                        How can you exercise your rights provided under the
                        GDPR?
                    </h2>
                    <p>
                        Under the UK General Data Protection Regulation, you
                        have the right to access, rectify, restrict, port and
                        erase your data. You can do this at any time at any time
                        through our supporter care service 0191 246 9123 or by
                        emailing{" "}
                        <Link href="mailto:supportercare@stoswaldsuk.org">
                            <a className="ml-1 text-loving-500">
                                supportercare@stoswaldsuk.org
                            </a>
                        </Link>
                        . If you are not satisfied with our response then you
                        can raise a concern directly with the Information
                        Commissioners&apos; Office (ICO) -
                        <Link href="https://ico.org.uk/make-a-complaint/data-protection-complaints/">
                            <a className="ml-1 text-loving-500">
                                Data protection complaints | ICO
                            </a>
                        </Link>
                    </p>

                    <h2 className="text-2xl ml-6 mt-4">
                        Data retention, account deactivation and deletion
                    </h2>
                    <p>
                        We store data until it is no longer necessary to provide
                        our services or until your account is deleted –
                        whichever comes first. When you delete your account, we
                        delete things that you have posted, such as your photos
                        and status updates, and you won&apos;t be able to recover
                        this information later. Information that others have
                        posted on the individual pages that they own isn&apos;t part
                        of your account and won&apos;t be deleted. If you don&apos;t want
                        to delete your account but want to temporarily stop
                        using Light up a Life, you can deactivate your account
                        instead. To delete your account at any time, please
                        contact our supporter care service 0191 246 9123 or by
                        emailing
                        <Link href="mailto:supportercare@stoswaldsuk.org">
                            <a className="ml-1 text-loving-500">
                                supportercare@stoswaldsuk.org
                            </a>
                        </Link>
                        .
                    </p>

                    <h2 className="text-2xl ml-6 mt-4">
                        How do we respond to legal requests or prevent harm?
                    </h2>
                    <p>
                        We access, preserve and share your information with
                        regulators, law enforcement or others:
                    </p>
                    <p>
                        In response to a legal request, if we have a good-faith
                        belief that the law requires us to do so. We can also
                        respond to legal requests when we have a good-faith
                        belief that the response is required by law in that
                        jurisdiction, affects users in that jurisdiction and is
                        consistent with internationally recognised standards.
                    </p>
                    <p>
                        When we have a good-faith belief that it is necessary
                        to: detect, prevent and address fraud, unauthorised use
                        of Light up a Life, breaches of our Terms or Policies,
                        or other harmful or illegal activity; to protect
                        ourselves, you or others, including as part of
                        investigations or regulatory enquiries; or to prevent
                        death or imminent bodily harm. For example, if relevant,
                        we provide information to and receive information from
                        third-party partners about the reliability of your
                        account to prevent fraud, abuse and other harmful
                        activity on and off Light up a Life.
                    </p>

                    <p>
                        Information that we receive about you (including
                        financial transaction data related to purchases made on
                        Light up a Life) can be accessed and preserved for an
                        extended period when it is the subject of a legal
                        request or obligation, governmental investigation or
                        investigations of possible violations of our terms or
                        policies, or otherwise to prevent harm. We also retain
                        information from accounts disabled for term breaches for
                        at least a year to prevent repeat abuse or other term
                        breaches.
                    </p>

                    <h2 className="text-2xl ml-6 mt-4">
                        How will we notify you of changes to this Policy?
                    </h2>
                    <p>
                        We&apos;ll notify you before we make changes to this Policy
                        and give you the opportunity to review the revised
                        Policy before you choose to continue using Light up a
                        Life.
                    </p>

                    <h2 className="text-2xl ml-6 mt-4">
                        How to contact us with questions
                    </h2>
                    <p>
                        You can learn more about how privacy works on Light up a
                        Life. If you have questions about this policy, you can
                        contact us as described below. You can also review St
                        Oswald&apos;s Hospice Privacy Policy for more detailed
                        information about how the Hospice uses and protects your
                        data.
                    </p>
                    <p>
                        The data controller responsible for your information is
                        St Oswald&apos;s Hospice, which you can contact online or by
                        writing to:
                    </p>
                    <ul className="list-none ml-4">
                        <li>
                            <Link href="mailto:DataProtectionOfficer@stoswaldsuk.org">
                                <a className="text-loving-500">
                                    DataProtectionOfficer@stoswaldsuk.org
                                </a>
                            </Link>
                        </li>
                        <li>Data Protection Officer</li>
                        <li>St Oswald&apos;s Hospice</li>
                        <li>Regent Avenue</li>
                        <li>Gosforth</li>
                        <li>Newcastle upon Tyne</li>
                        <li>NE3 1EE</li>
                    </ul>
                </div>
            </div>
        </>
    );
}
